import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _classCallCheck from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _inherits from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import _possibleConstructorReturn from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// User Model
import Vue from 'vue';
import VuexORM from '@vuex-orm/core';
import AccountIntegration from "./AccountIntegration";
import SubscriptionType from "./SubscriptionType";
import Project from "./Project";
import TagList from "./TagList";
import Note from "./Note";
import Avatar from "./Avatar";
import Integration from "./Integration";
import Feature from "./Feature";
import AccountFeature from "./AccountFeature";
import User from "./User";
import moment from 'moment';

var Account = /*#__PURE__*/function (_VuexORM$Model) {
  _inherits(Account, _VuexORM$Model);

  var _super = _createSuper(Account);

  function Account() {
    _classCallCheck(this, Account);

    return _super.apply(this, arguments);
  }

  _createClass(Account, [{
    key: "featureExists",
    value: function featureExists(featureCode) {
      return AccountFeature.find([this.account_id, featureCode]);
    }
  }, {
    key: "hasFeature",
    value: function hasFeature(featureCode) {
      var featurePivot = this.featureExists(featureCode);
      return !!featurePivot && featurePivot.enabled;
    }
  }, {
    key: "hasDisabledFeature",
    value: function hasDisabledFeature(featureCode) {
      return this.hasFeatureAccess(featureCode) && !this.hasFeature(featureCode);
    }
  }, {
    key: "hasFeatureAccess",
    value: function hasFeatureAccess(featureCode) {
      var _this = this;

      var feature = Feature.find(featureCode);

      if (feature && feature.subscription_types) {
        var subscriptionTypeIds = feature.subscription_types.map(function (subscriptionType) {
          return subscriptionType.subscription_type_id;
        });
        return !!subscriptionTypeIds.find(function (id) {
          return id === _this.subscription_type_id;
        }) || !!this.featureExists(featureCode);
      }

      return !!this.featureExists(featureCode);
    }
  }, {
    key: "availableFeatures",
    value: function availableFeatures() {
      return AccountFeature.query().where('account_id', this.account_id).all();
    }
  }, {
    key: "getApprovalPeriods",
    value: function getApprovalPeriods(from, to) {
      var _this2 = this;

      moment.updateLocale(User.me().settings.appLanguage || 'en', {
        week: {
          dow: this.settings.approval_workweek_begin
        }
      });
      var range = moment.range(from, to);
      var periods = [];

      switch (this.settings.approval_period) {
        case 'biweekly':
          range.start = range.start.startOf('week');
          periods = Array.from(range.by('weeks', {
            step: 2
          }));
          break;

        case 'monthly':
          range.start = range.start.startOf('month');
          periods = Array.from(range.by('months', {
            step: 1
          }));
          break;

        case 'weekly':
        default:
          range.start = range.start.startOf('week');
          periods = Array.from(range.by('weeks', {
            step: 1
          }));
          break;
      }

      return periods.map(function (date) {
        var dateFrom = date;
        var dateTo = date.clone().add(_this2.settings.approval_period === 'biweekly' ? 1 : 0, 'week').endOf(_this2.settings.approval_period === 'monthly' ? 'month' : 'week');
        return {
          formatted_date: dateFrom.format('YYYY-MM-DD'),
          date_from: dateFrom,
          date_to: dateTo
        };
      });
    }
  }, {
    key: "checkValidApprovalPeriod",
    value: function checkValidApprovalPeriod(dateFrom, dateTo) {
      // generate a range of periods based on approval settings
      var periods = this.getApprovalPeriods(this.settings.approval_recurrence_start, moment());
      return periods.some(function (period) {
        return moment(dateFrom).isSame(period.date_from, 'day') && moment(dateTo).isSame(period.date_to, 'day');
      });
    }
  }], [{
    key: "entity",
    get: // This is the name used as module name of the Vuex Store.
    function get() {
      return 'accounts';
    }
  }, {
    key: "primaryKey",
    get: function get() {
      return 'account_id';
    }
  }, {
    key: "fields",
    value: // List of all fields (schema) of the post model. `this.attr` is used
    // for the generic field type. The argument is the default value.
    function fields() {
      return {
        account_id: this.attr(null),
        account_name: this.attr(''),
        created_date: this.attr(''),
        active_users_count: this.attr(0),
        can_revert_v2: this.attr(false),
        allows_password_management: this.attr(false),
        session_last_time: this.attr(''),
        deletion_requested: this.attr(null),
        subscription_limit_users: this.number(1),
        next_renew_licences: this.number(1),
        is_trial: this.boolean(false),
        is_free: this.boolean(false),
        billing_enabled: this.boolean(false),
        is_educational: this.boolean(false),
        is_noprofit: this.boolean(false),
        expiration: this.attr(''),
        company_size: this.attr(''),
        industry_type: this.attr(null),
        industry_type_text: this.attr(''),
        users_invite_target: this.attr(''),
        setup_features: this.attr(null),
        setup_completed: this.attr(false),
        setup_all_completed: this.attr(false),
        is_exporting: this.attr(false),
        settings: this.attr(''),
        disk_space_availability: this.attr(null),
        stripe_customer: this.attr(''),
        subscription_type_id: this.attr(null),
        subscription_duration: this.attr(''),
        stripe_id: this.attr(null),
        payment_processor: this.attr(null),
        health_score: this.attr(0),
        subscription_type: this.hasOne(SubscriptionType, 'subscription_type_id', 'subscription_type_id'),
        avatar: this.hasOne(Avatar, 'account_id', 'account_id'),
        integrations: this.belongsToMany(Integration, AccountIntegration, 'account_id', 'integration_code'),
        projects: this.hasMany(Project, 'account_id', 'account_id'),
        tag_lists: this.hasMany(TagList, 'account_id', 'account_id'),
        notes: this.hasMany(Note, 'account_id', 'account_id'),
        features: this.belongsToMany(Feature, AccountFeature, 'account_id', 'feature_code')
      };
    }
  }, {
    key: "$deleteDemoData",
    value: function $deleteDemoData(id) {
      return Vue.prototype.$axios.post('/accounts/' + id + '/delete-demo-data');
    }
  }]);

  return Account;
}(VuexORM.Model);

_defineProperty(Account, "state", {
  pending: false,
  lastSync: null
});

_defineProperty(Account, "apiConfig", {
  actions: {
    loadIntegrations: function loadIntegrations(id, params) {
      return this.get('/integrations', {
        params: _objectSpread({
          target_account: 1,
          sort_by: 'name',
          direction: 'asc'
        }, params),
        save: false
      });
    },
    updateSubscriptionLicenses: function updateSubscriptionLicenses(id, licenses) {
      return this.put('/accounts/' + id + '/subscription-licenses', {
        licenses: licenses
      });
    }
  }
});

export { Account as default };